import { render, staticRenderFns } from "./DataTableVT.vue?vue&type=template&id=22acf63a&scoped=true"
import script from "./DataTableVT.vue?vue&type=script&lang=js"
export * from "./DataTableVT.vue?vue&type=script&lang=js"
import style0 from "./DataTableVT.vue?vue&type=style&index=0&id=22acf63a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22acf63a",
  null
  
)

export default component.exports